import DesktopUserListingPage, { userTableParams } from "../../admin/users/DesktopUserListingPage";
import ClinicUsers from "../../../contexts/ClinicUsers";
import { useGetUsersTable } from "../../admin/users/hooks/useGetUsersTable";
import { useSearchParams } from "react-router-dom";
import useUser from "../../../hooks/useUser";

export default function ClinicUsersMasterView() {
   const [searchParams] = useSearchParams();
    const { preferance } = useUser();
  
  const page = parseInt(searchParams.get(userTableParams.page)) || 0;
  const size = parseInt(searchParams.get(userTableParams.rowsPerPage)) || Number(preferance?.clinicUsersTableRowsPerPage) || 10;
  const q = searchParams.get(userTableParams.wildcard) || '';
  const clinicId = searchParams.get(userTableParams.clinic) || "";
  const sortParam = searchParams.get('sort') || '';
  const sort = sortParam ? sortParam : 'id=asc'; 
  const activeParam = searchParams.get(userTableParams.active);
  const withoutPetsParam = searchParams.get(userTableParams.withoutPets);
  const withoutReservationsParam = searchParams.get(userTableParams.withoutReservations);

    const active = activeParam !== null ? activeParam === "true" : null;
  const withoutPets = withoutPetsParam !== null ? withoutPetsParam === 'true' : null;
  const withoutReservations = withoutReservationsParam !== null ? withoutReservationsParam === 'true' : null;

  const { data, isLoading, error } = useGetUsersTable(page, size, q, sort, clinicId, active,withoutPets,withoutReservations);
  return (
    <ClinicUsers data={data} loading={isLoading} error={error}>
      <DesktopUserListingPage />
    </ClinicUsers>
  );
}
